import React from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';

const NAV = [
  { id: 'dashboard',  label: 'Dashboard',          icon: '📊' },
  { id: 'todaysjobs', label: "Today's Jobs",        icon: '🔧' },
  { id: 'schedule',   label: 'Schedule',            icon: '📅' },
  { id: 'services',   label: 'Services & Pricing',  icon: '💰' },
  { id: 'locations',  label: 'Locations',           icon: '📍' },
  { id: 'drivers',    label: 'Driver Coordination', icon: '🚗' },
  { id: 'payments',   label: 'Payments',            icon: '💳' },
  { id: 'reports',    label: 'Reports & Analytics', icon: '📈' },
  { id: 'profile',    label: 'Business Profile',    icon: '🏢' },
  { id: 'team',       label: 'Team Members',        icon: '👥' },
  { id: 'settings',   label: 'Settings',            icon: '⚙️' },
];

export default function Sidebar({ activeTab, setActiveTab, user, centerData }) {
  return (
    <aside style={{ width: 240, background: 'var(--dark)', color: '#fff', display: 'flex', flexDirection: 'column', height: '100vh', flexShrink: 0 }}>
      {/* Logo */}
      <div style={{ padding: '24px 20px 20px', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
        <div style={{ fontSize: 22, fontWeight: 900 }}>Coco<span style={{ color: 'var(--orange)' }}>Wash</span></div>
        <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', marginTop: 2 }}>Service Center Portal</div>
      </div>

      {/* Business name */}
      {centerData && (
        <div style={{ padding: '14px 20px', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--orange)', marginBottom: 2 }}>{centerData.businessName}</div>
          <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)' }}>
            {centerData.status === 'approved' ? '✅ Approved' : centerData.status === 'pending' ? '⏳ Pending Approval' : centerData.status}
          </div>
        </div>
      )}

      {/* Nav items */}
      <nav style={{ flex: 1, overflowY: 'auto', padding: '12px 0' }}>
        {NAV.map(item => (
          <button
            key={item.id}
            onClick={() => setActiveTab(item.id)}
            style={{
              display: 'flex', alignItems: 'center', gap: 10, width: '100%', padding: '10px 20px',
              background: activeTab === item.id ? 'rgba(249,115,22,0.15)' : 'transparent',
              borderLeft: activeTab === item.id ? '3px solid var(--orange)' : '3px solid transparent',
              border: 'none', color: activeTab === item.id ? 'var(--orange)' : 'rgba(255,255,255,0.7)',
              fontSize: 13, fontWeight: activeTab === item.id ? 700 : 500, cursor: 'pointer', textAlign: 'left',
            }}
          >
            <span style={{ fontSize: 16 }}>{item.icon}</span>
            {item.label}
          </button>
        ))}
      </nav>

      {/* User info + sign out */}
      <div style={{ padding: '16px 20px', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
        <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)', marginBottom: 10, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{user?.email}</div>
        <button onClick={() => signOut(auth)} style={{ width: '100%', padding: '8px', background: 'rgba(255,255,255,0.08)', border: 'none', borderRadius: 8, color: 'rgba(255,255,255,0.6)', fontSize: 12, cursor: 'pointer', fontWeight: 600 }}>Sign Out</button>
      </div>
    </aside>
  );
}